export default __webpack_public_path__ + "static/media/image3.a9beeb98.png";